/* eslint-disable no-useless-constructor */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Navbar from './common/Navbar';
import Bet from './bet/';
import Roll from '../components/bet/Roll';
import Chat from './chat';
import * as authActions from '../actions/auth';

import '../css/main.css';

function mapStateToProps(state) {
    return {
       auth: state.auth
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userUpdate: authActions.userUpdate,
        logout: authActions.logout
    }, dispatch)
}

class App extends Component {
    render(){
        const { user, balances } = this.props.auth;
        return (
             <main>
                <Navbar 
                  user={user}
                  userLogin={this.props.userUpdate}
                />
                <Bet 
                  balances={balances} 
                />
                <Roll />
                <Chat u={user}/>
             </main>
        )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);


// WEBPACK FOOTER //
// ./src/components/App.js